const SHARE_CANCEL_TEXT = 'Share cancelled';

function isShareCancelError(error) {
  if (!error) {
    return false;
  }

  if (error.name === 'AbortError') {
    return true;
  }

  if (typeof error.message === 'string' && error.message.toLowerCase().includes('cancel')) {
    return true;
  }

  return false;
}

export function handleShareFailure(error, stateHandler, context = 'Share') {
  if (isShareCancelError(error)) {
    stateHandler?.set('temporalPopup', { text: SHARE_CANCEL_TEXT, type: 'no-navigation' });
    return;
  }

  console.error(`${context} failed`, error);
}
